<div class="panel-group" role="tablist" aria-multiselectable="true">
  <div class="panel" id="panelFilter">
    <div class="panel-heading" role="tab" id="headingFilter">
      <h4 class="panel-title">
        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordionFilter" href="#collapseFilter"
          aria-expanded="false" aria-controls="collapseFilter">
          <span class="material-icons">filter_alt</span> Filtros
        </a>
      </h4>
    </div>
    <div id="collapseFilter" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFilter"
      aria-expanded="false">
      <div class="panel-body">
        <div class="row">
          <div class="col-md-2">
            <mat-form-field>
              <mat-label>Tipo Filtro</mat-label>
              <mat-select [(ngModel)]="search.option">
                <mat-option *ngFor="let option of filterOptions" [value]="option.value">{{option.text}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field>
              <mat-label>Pesquisar por</mat-label>
              <input matInput type="text" [(ngModel)]="search.searchTerm" (keyup.enter)="filter()" />
              <mat-error>Informe um Nome Apresentação.</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="panel-footer" style="text-align: right">
        <mat-slide-toggle style="margin-right: 10px;" color="primary" [(ngModel)]="searchRegistroAtivo.searchTerm">
          Somente Reg.Ativos
        </mat-slide-toggle>
        <button mat-flat-button color="primary" (click)="filter()">
          <span>Filtrar</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="header">
    <h2>Equipamentos</h2>
  </div>
  <div class="body table-responsive">
    <table datatable [dtOptions]="dtOptions" *ngIf="dtOptions" class="table table-bordered table-striped table-hover"
      style="width: 100%;">
      <thead>
        <tr>
          <th class="text-center">Nome</th>
          <th class="text-center" width="50">Conf.Lote</th>
          <th class="text-center">Pré-Requisitos</th>
          <th class="text-center">Captura Imagem?</th>
          <th class="text-center" width="50">Ativo</th>
          <th class="text-center" width="150"></th>
        </tr>
      </thead>
      <tbody *ngIf="models?.length != 0">
        <tr *ngFor="let item of models">
          <td [innerHTML]="item.nomeApresentacao"></td>
          <td>
            {{typesService.getBoolTypeNome(item.usaConfirmacaoLote)}}
          </td>
          <td [innerHTML]="item.preRequisitos"></td>
          <td>
            {{typesService.getBoolTypeNome(item.capturaImagem)}}
          <td>
            {{typesService.getBoolTypeNome(item.registroAtivo)}}
          </td>
          <td class="text-center">
            <button [disabled]="!isAllowed('Update')" mat-icon-button type="button"
              (click)="agendaDispModal.show(item.profissionalRecursoId, item.nomeApresentacao)"
              matTooltip="Disponibilidade da Agenda">
              <mat-icon>alarm</mat-icon>
            </button>
            <button [disabled]="!isAllowed('Update')" mat-icon-button type="button"
              (click)="agendaBloqueioModal.show(item.profissionalRecursoId, item.nomeApresentacao)"
              matTooltip="Bloqueios da Agenda">
              <mat-icon>block</mat-icon>
            </button>
            <button [disabled]="!isAllowed('Update')" mat-icon-button type="button" (click)="edit(item)"
              matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button [disabled]="!isAllowed('Delete')" mat-icon-button type="button" (click)="delete(item.id)"
              matTooltip="Excluir">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="fixed-action-btn">
    <button [disabled]="!isAllowed('Create')" mat-fab color="primary" (click)="create()" matTooltip="Adicionar (F9)"
      matTooltipPosition="above">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
<app-equipamento-modal #modal (modalSave)="onResponse($event)"></app-equipamento-modal>
<app-agenda-disponibilidade #agendaDispModal></app-agenda-disponibilidade>
<app-agenda-bloqueio #agendaBloqueioModal></app-agenda-bloqueio>